import { motion } from "framer-motion";
import { Play, Tv } from "lucide-react";

const REPORTAGE_URL =
  "https://www.tf1info.fr/conso/video-reportage-on-est-obliges-d-importer-voici-d-ou-vient-vraiment-la-tres-grande-majorite-des-escargots-de-bourgogne-2410649.html";

const Presse = () => {
  return (
    <section data-testid="presse-section" id="presse" className="py-24 lg:py-32 bg-sable">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <motion.a
          href={REPORTAGE_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="presse-video-link"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="group relative block rounded-[2rem] overflow-hidden shadow-[0_18px_50px_rgba(44,42,40,0.2)]"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/q3f2kau8_WhatsApp%20Image%202026-07-02%20at%2010.19.13%20%289%29.jpeg"
            alt="Reportage TF1 sur les escargots de Bourgogne"
            className="w-full h-[380px] sm:h-[460px] object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/30" />

          <div className="absolute inset-0 flex flex-col justify-center px-8 sm:px-14 max-w-2xl">
            <div className="flex items-center gap-2 text-creme">
              <Tv size={18} />
              <span className="text-sm uppercase tracking-[0.3em] font-500">Vu au JT de 20h · TF1</span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl text-white mt-4 tracking-tight leading-tight">
              L'élevage d'escargots "gros gris" en Bourgogne
            </h2>
            <p className="text-white/80 mt-4 leading-relaxed max-w-lg">
              D'où viennent vraiment les escargots de Bourgogne ? Découvrez le reportage du 20h
              de TF1 et le savoir-faire d'un véritable élevage français.
            </p>

            <div className="mt-8 inline-flex items-center gap-3">
              <span className="w-14 h-14 rounded-full bg-bordeaux text-white flex items-center justify-center shadow-lg transition-transform group-hover:scale-110">
                <Play size={22} className="ml-0.5 fill-white" />
              </span>
              <span className="text-white font-600">Regarder le reportage</span>
            </div>
          </div>
        </motion.a>
      </div>
    </section>
  );
};

export default Presse;
